import { PageComposerModel } from 'common/models/page-composer.model';
import alignmentCountersWidget from '../widget-catalog/widget-configs/alignment_counters.json';
import alignmentOverviewWidget from '../widget-catalog/widget-configs/alignment_detail_overview.json';
import alignmentResponseVolume from '../widget-catalog/widget-configs/alignment_response_volume.json';
import alignmentLatestAlignment from '../widget-catalog/widget-configs/alignment_response_volume_over_time.json';
import alignmentMovement from '../widget-catalog/widget-configs/alignment_movement.json';
import alignmentShift from '../widget-catalog/widget-configs/alignment_shift.json';
import alignmentResponseDetail from '../widget-catalog/widget-configs/alignment_response_detail.json';
import elsieAiExport from '../widget-catalog/widget-configs/elsie_ai_export.json';
import elsieAiSummary from '../widget-catalog/widget-configs/elsie_ai_summary.json';
import { WidgetModel } from 'common/models/widget.model';
import { globalPageConfigs } from './pageConfigs.const';

// We have to cast the widgets to WidgetModel because the widget configs are imported as JSON
const widgetCounters = alignmentCountersWidget.widget as unknown as WidgetModel;
const widgetAlignmentOverview = alignmentOverviewWidget.widget as unknown as WidgetModel;
const widgetResponseVolume = alignmentResponseVolume.widget as unknown as WidgetModel;
const widgetLatestAlignment = alignmentLatestAlignment.widget as unknown as WidgetModel;
const widgetMovement = alignmentMovement.widget as unknown as WidgetModel;
const widgetShift = alignmentShift.widget as unknown as WidgetModel;
const widgetResponseDetail = alignmentResponseDetail.widget as unknown as WidgetModel;
const widgetElsieAiExport = elsieAiExport as unknown as WidgetModel;
const widgetElsieAiSummary = elsieAiSummary as unknown as WidgetModel;

const alignmentDetailConfig: PageComposerModel = {
  ...globalPageConfigs,
  pageName: 'alignment-detail',
  pageTitle: 'Alignment Detail',
  waitForDatasetQuestion: true,
  widgets: [
    widgetCounters,
    widgetAlignmentOverview,
    widgetResponseVolume,
    widgetLatestAlignment,
    widgetMovement,
    widgetShift,
    widgetResponseDetail,
    widgetElsieAiExport,
    widgetElsieAiSummary,
  ],
};

export default alignmentDetailConfig;
